import { CvSectionProfileSexEnum } from '@/../gen';

export default {
  image: '画像',
  full_name: 'フルネーム',
  birthday: '生年月日',
  sex: '性別',
  sexes: {
    [CvSectionProfileSexEnum.NotKnown]: '未回答',
    [CvSectionProfileSexEnum.Male]: '男',
    [CvSectionProfileSexEnum.Female]: '女',
    [CvSectionProfileSexEnum.NotApplicable]: 'その他',
  },
  email: 'メールアドレス',
  phone_number: '電話番号',
  location: '現住所',
  headline: '肩書',
  website_url: 'URL',
};
